/** Shared documentation navigation structure */

export interface DocNavItem {
  label: string;
  to: string;
}

export interface DocNavSection {
  title: string;
  items: DocNavItem[];
}

export interface DocTab {
  id: string;
  label: string;
  /** First route in this tab — used as navigation target when tab is clicked */
  defaultRoute: string;
  /** Sidebar sections shown when this tab is active */
  sections: DocNavSection[];
  /** All route paths belonging to this tab */
  routes: string[];
}

export const docTabs: DocTab[] = [
  {
    id: 'getting-started',
    label: 'Getting Started',
    defaultRoute: '/documentation/overview',
    sections: [
      {
        title: 'Getting Started',
        items: [
          { label: 'Overview', to: '/documentation/overview' },
          { label: 'Streaming Guide', to: '/documentation/streaming-guide' },
          { label: 'Local Agent', to: '/documentation/local-agent' },
          { label: 'Interlucent Uploader', to: '/documentation/interlucent-uploader' },
        ],
      },
      {
        title: 'Engine Guides',
        items: [
          { label: 'Unreal Engine', to: '/documentation/streaming-guide-unreal' },
          { label: 'Unity', to: '/documentation/streaming-guide-unity' },
        ],
      },
    ],
    routes: [
      '/documentation/overview',
      '/documentation/streaming-guide',
      '/documentation/local-agent',
      '/documentation/interlucent-uploader',
      '/documentation/streaming-guide-unreal',
      '/documentation/streaming-guide-unity',
    ],
  },
  {
    id: 'reference',
    label: 'Reference',
    defaultRoute: '/documentation/tolerances',
    sections: [
      {
        title: 'Configuration',
        items: [
          { label: 'Session Behavior', to: '/documentation/tolerances' },
          { label: 'Network Connectivity', to: '/documentation/network-connectivity-requirements' },
        ],
      },
      {
        title: 'SDK',
        items: [
          { label: 'SDK Reference', to: '/documentation/sdk-reference' },
          { label: 'Idle Timer', to: '/documentation/idle-timer' },
        ],
      },
    ],
    routes: [
      '/documentation/tolerances',
      '/documentation/network-connectivity-requirements',
      '/documentation/sdk-reference',
      '/documentation/idle-timer',
    ],
  },
];

/** Find which tab owns a given route path */
export function getActiveTab(pathname: string): DocTab | undefined {
  return docTabs.find((tab) => tab.routes.some((r) => pathname.startsWith(r)));
}

/** Get the breadcrumb label for a route */
export function getBreadcrumbLabel(pathname: string): string | undefined {
  const tab = getActiveTab(pathname);
  return tab?.label;
}
